var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-checkbox',{class:['checkbox'],attrs:{"label":_vm.label,"disabled":_vm.disabled,"name":_vm.name,"value":_vm.value,"input-value":_vm.inputValue,"readonly":_vm.readonly,"multiple":_vm.multiple},on:{"change":_vm.onChange}},[_vm._t("label",null,{"slot":"label"})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }